function envApiUrl(): string | undefined {
  const fromVite =
    (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) || undefined;
  if (fromVite) return fromVite;
  if (typeof process !== "undefined") return process.env.VITE_API_URL;
  return undefined;
}

/** Browser-facing API base (direct to API host in prod; localhost:4000 in dev). */
export function publicApiUrl(): string {
  return envApiUrl() ?? "/backend";
}

async function readJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || res.statusText);
  }
  return res.json() as Promise<T>;
}

/** Browser fetch to the API with session cookies. */
export async function clientApi<T>(path: string, init?: RequestInit): Promise<T> {
  const base = publicApiUrl();
  const headers = new Headers(init?.headers);
  // Free ngrok serves an HTML interstitial without CORS headers unless skipped.
  if (base.includes("ngrok")) headers.set("ngrok-skip-browser-warning", "true");

  const res = await fetch(`${base}${path}`, {
    ...init,
    headers,
    credentials: "include",
  });

  return readJson<T>(res);
}

/**
 * @deprecated Use `clientApi` — kept as an alias so call sites that still say
 * `serverApi` keep working after the SPA migration.
 */
export const serverApi = clientApi;
